<template>
  <section class="bed" data-testid="vigilance-elements-devis">
    <h4 class="bed-title">
      <i class="fas fa-calculator" aria-hidden="true"></i>
      Éléments à prendre en compte pour le devis
    </h4>
    <ul v-if="elements.length" class="bed-list">
      <li
        v-for="element in elements"
        :key="element.key"
        class="bed-item"
        :data-testid="`vigilance-element-${element.key}`"
      >
        <i :class="element.icon" aria-hidden="true"></i>
        <span>{{ element.texte }}</span>
      </li>
    </ul>
    <p v-else class="bed-none" data-testid="vigilance-elements-aucun">
      Rien de particulier : ni entreprise en difficulté, ni horaires de nuit, ni formation le week-end.
    </p>
  </section>
</template>

<script setup>
/**
 * « ÉLÉMENTS À PRENDRE EN COMPTE POUR LE DEVIS », dans le Point de vigilance :
 * ce qui peut changer le prix, rappelé au moment d'éditer le devis. Le calcul
 * est dans `elementsAPrendreEnCompte` ; ici, l'affichage seul.
 */
import { computed } from 'vue'
import { elementsAPrendreEnCompte } from '../../utils/elementsDevis.js'

const props = defineProps({
  /** La demande telle qu'affichée (snake_case). */
  quote: { type: Object, default: null }
})

const elements = computed(() => elementsAPrendreEnCompte(props.quote))
</script>

<style scoped>
.bed {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.bed-title {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  margin: 0;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.bed-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.bed-item {
  display: flex;
  align-items: baseline;
  gap: var(--spacing-2);
  padding: var(--spacing-2) var(--spacing-3);
  border: 1px solid var(--color-warning-lighter);
  border-radius: var(--radius-md);
  background: var(--color-warning-lightest);
  color: var(--color-warning-darker);
  font-size: var(--font-size-sm);
  line-height: 1.5;
}

.bed-none {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}
</style>
